import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { User } from '../types/User';

const URL = '/v2/users';

interface UserSearchParams {
  searchTerm?: string;
  userType?: 'parent' | 'sitter' | 'agency' | 'all';
  page?: number;
  limit?: number;
}

class UserService {
  static get(
    id: number,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<User>> {
    return axios.get(`${URL}/${id}`, config);
  }

  static getByFilter(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<User>> {
    return axios.get(URL, config);
  }

  static search(params: UserSearchParams): Promise<PagedResponse<User>> {
    const config: AxiosRequestConfig = {
      params: {
        searchTerm: params.searchTerm,
        userType: params.userType !== 'all' ? params.userType : undefined,
        page: params.page ?? 1,
        limit: params.limit ?? 20,
      },
    };
    return axios.get(URL, config);
  }

  static patch(
    id: number,
    data: User,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<User>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }
}
export { UserService };
